export class SysInfo {
    public readonly name: string = process.env.REACT_APP_SYS_NAME;
    public readonly url: string = process.env.REACT_APP_SYS_URL;
    public readonly company: string = process.env.REACT_APP_SYS_COMPANY;
    public readonly regCode: string = process.env.REACT_APP_SYS_REGCODE;
    public readonly address: string = process.env.REACT_APP_SYS_ADDRESS;
    public readonly email: string = process.env.REACT_APP_SYS_EMAIL;
    public readonly phone: string = process.env.REACT_APP_SYS_PHONE;
    public readonly facebook: string = process.env.REACT_APP_SYS_FACEBOOK;
    public readonly instagram: string = process.env.REACT_APP_SYS_INSTAGRAM;
}



// WEBPACK FOOTER //
// ./src/models/sys/sys-info.ts